import { render, staticRenderFns } from "./AlternativeTabTitle.vue?vue&type=template&id=fee59f3a&scoped=true&"
import script from "./AlternativeTabTitle.vue?vue&type=script&lang=js&"
export * from "./AlternativeTabTitle.vue?vue&type=script&lang=js&"
import style0 from "./AlternativeTabTitle.vue?vue&type=style&index=0&id=fee59f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee59f3a",
  null
  
)

export default component.exports